import { Injectable, EventEmitter } from '@angular/core';

import * as dp from 'dicom-parser';
import { ApiService } from '@radsource/ng-common-lib';

import { of } from 'rxjs';
import { MessageService } from '@radsource/ng-common-lib';
import { CMoveRequest } from '../objects/cmove-request';

@Injectable({
	providedIn: 'root',
})
export class DicomService {

  dicomLib: any;
  activeEchoes: any = [];
  activeEchoes$: any;

  cMoveRequests: Array<CMoveRequest> = new Array<CMoveRequest>();
  cMoveRequests$: any;

  sopsPushing: number;
  sopsPushing$: any;

  sopsAttempted: number;
  sopsAttempted$: any;

  sopsTotal: number = 0;
  sopsTotal$: any;

  sopsFailed: number = 0;
  sopsFailed$: any;

  sopsCanceled: number = 0;
  sopsCanceled$: any;

  sopsRemaining: number = 0;
  sopsRemaining$: any;

  sopsWarned: number = 0;
  sopsWarned$: any;

  sopsSuccess: number = 0;
  sopsSuccess$: any;

  percentageSOPsPushed: number;
  percentageSOPsPushed$: any;

  pushing: Boolean = false;
  pushing$: any;

  transferring: Boolean = false;
  transferring$: any;

  pushAttempted: Boolean = false;
  pushAttempted$: any;

  showFailedImages: Boolean = false;
  showFailedImages$: any;

  cancelationRequested: Boolean = false;

  constructor(private api: ApiService, private ms: MessageService) {
    this.dicomLib = dp;
  }

  aggregateSOPs(): any {

      this.sopsSuccess = (this.cMoveRequests.length > 0) ? this.cMoveRequests.map(r => r.sops_complete).reduce((a, b) => a + b, 0) : 0;
      this.sopsSuccess$ = of(this.sopsSuccess);

      this.sopsFailed = (this.cMoveRequests.length > 0) ? this.cMoveRequests.map(r => r.sops_failed).reduce((a, b) => a + b, 0) : 0;
      this.sopsFailed$ = of(this.sopsFailed);

      this.sopsCanceled = (this.cMoveRequests.length > 0) ? this.cMoveRequests.map(r => r.sops_canceled).reduce((a, b) => a + b, 0) : 0;
      this.sopsCanceled$ = of(this.sopsCanceled);

      this.sopsWarned = (this.cMoveRequests.length > 0) ? this.cMoveRequests.map(r => r.sops_warning).reduce((a, b) => a + b, 0) : 0;
      this.sopsWarned$ = of(this.sopsWarned);

      this.sopsRemaining = (this.cMoveRequests.length > 0) ? this.cMoveRequests.map(r => r.sops_remaining).reduce((a, b) => a + b, 0) : 0;
      this.sopsRemaining$ = of(this.sopsRemaining);

      this.sopsTotal = (this.cMoveRequests.length > 0) ? this.sopsRemaining + this.sopsFailed + this.sopsCanceled + this.sopsSuccess + this.sopsWarned : 0;
      this.sopsTotal$ = of(this.sopsTotal);

      this.sopsAttempted = (this.cMoveRequests.length > 0) ? this.sopsFailed + this.sopsSuccess + this.sopsCanceled + this.sopsWarned : 0;
      this.sopsAttempted$ = of(this.sopsAttempted);

      this.percentageSOPsPushed = Math.round((this.sopsAttempted / this.sopsTotal) * 100);
      this.percentageSOPsPushed$ = of(this.percentageSOPsPushed);

    }

  updatePushFlags(): any {
    if (this.cMoveRequests.length > 0) {
      this.pushing = true;
      this.pushing$ = of(this.pushing);

      this.transferring = true;
      this.transferring$ = of(this.transferring);

      this.pushAttempted = true;
      this.pushAttempted$ = of(this.pushAttempted);

      this.aggregateSOPs();

      if (this.sopsAttempted == this.sopsTotal) {
        // this.pushing = false;
        // this.pushing$ = of(this.pushing);
        this.transferring = false;
        this.transferring$ = of(this.transferring);
      } else {
        this.pushAttempted = false;
        this.pushAttempted$ = of(this.pushAttempted);
      }

    } else {
      this.aggregateSOPs();
      this.pushing = false;
      this.pushing$ = of(this.pushing);
      this.transferring = false;
      this.transferring$ = of(this.transferring);
      this.pushAttempted = false;
      this.pushAttempted$ = of(this.pushAttempted);
    }

    if (this.pushAttempted == true) {
      this.calculateGlobalFailedImages();
    }
  }

  calculateGlobalFailedImages() {
    if (this.sopsSuccess < this.sopsTotal && this.sopsFailed != this.sopsTotal) {
      this.showFailedImages = true;
      this.showFailedImages$ = of(this.showFailedImages);
    }
  }

  bufferIsDicom(buffer: any): any {
    return new Promise((resolve, reject) => {
      try {
        let array = new Uint8Array(buffer);
        let result = this.dicomLib.parseDicom(array);
        resolve(true);
      }
      catch (ex) {
        resolve(false);
      }
    });
  }

  deleteAllCMoveRequests(): Promise<any> {
    return this.api.delete('cmove/requests/owner/').then((res) => res).catch((err) => this.ms.handleServerError(err));
  }

  allCMoveRequests(): any {
    return this.api.get('cmove/requests/owner/').then((res) => res).catch((err) => this.ms.handleServerError(err));
  }

  cEcho(values) {
    // test
    let echo = this.api.post('wado/cecho', values)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });

    // this.activeEchoes.push(echo);
    // this.activeEchoes$ = of(this.activeEchoes);
    return echo;
  }

  cMove(values) {

    return this.api.post('cmove/requests/owner/wadostudy/' + values.study_record_id + '/', values)
      .then((res) => {
        try {
          this.cMoveRequests.push(new CMoveRequest(res));
          this.cMoveRequests$ = of(this.cMoveRequests);
          return res;
        } catch (err) {
          this.ms.handleClientError(err);
        }
      })
      .catch((err: any) => {
        throw err;
      });
  }
}
